import { Shipment } from '@laco/backend-interfaces';
import { Document, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import Logo from '../Assets/laco-logo.png';
import { generalPageStyles, rowPadding, tableVerticalPadding } from '../Styles/reactPDF';

const styles = StyleSheet.create({
  packingListNumb: {
    justifyContent: 'center',
    textAlign: 'center',
    flex: 1,
    fontSize: 22,
  },
  shipToBillTo: {
    flex: 3,
    paddingHorizontal: 10,
    paddingBottom: 10,
    textAlign: 'justify',
  },
  quantityCell: { flex: 1, paddingVertical: tableVerticalPadding },
});

interface PackingListProps {
  packingList: Shipment.ShipmentHeader;
}

export const PackingList = (props: PackingListProps) => {
  const { packingList } = props;

  return (
    <Document
      title={`Packing List - ${packingList.shipmentNumber}`}
      subject={`Packing List - ${packingList.shipmentNumber}`}
      author='LACO INC'
      creator='Traverse'
    >
      <Page size='LETTER' style={generalPageStyles.page}>
        <View style={[generalPageStyles.row, { paddingBottom: rowPadding }]} fixed>
          <Image style={generalPageStyles.logo} src={Logo} />
          <View style={styles.packingListNumb}>
            <Text>{`Packing List - ${packingList.shipmentNumber}`}</Text>
          </View>
        </View>
        <View style={generalPageStyles.row}>
          <View style={styles.shipToBillTo}>
            <View>
              <Text style={generalPageStyles.textHeader}>Bill To:</Text>
            </View>
            <Text>{packingList.customer?.name}</Text>
            <Text>{packingList.customer?.address?.display}</Text>
          </View>
          <View style={styles.shipToBillTo}>
            <Text style={generalPageStyles.textHeader}>Ship To:</Text>
            {/* //TODO: Need shipTo name  */}
            <Text>{packingList.shipTo}</Text>
          </View>
        </View>
        <View style={generalPageStyles.table}>
          <View style={generalPageStyles.rowWithBorder}>
            <Text style={generalPageStyles.tableCellStart}>SO</Text>
            {/* <Text style={generalPageStyles.tableCell}>Ship Num</Text> */}
            <Text style={generalPageStyles.tableCell}>Cust No</Text>
            <Text style={generalPageStyles.tableCell}>Order Date</Text>
            <Text style={generalPageStyles.tableCell}>Tax</Text>
            <Text style={generalPageStyles.tableCell}>Sales Rep</Text>
            <Text style={{ flex: 3, paddingVertical: tableVerticalPadding }}>Customer P.O. Number</Text>
            <Text style={[generalPageStyles.tableCellEnd, { flex: 2 }]}>Mark Shipment</Text>
          </View>
          <View style={[generalPageStyles.rowWithBorder]}>
            <Text style={generalPageStyles.tableCellStart}>{packingList.salesOrderNumber}</Text>
            {/* <Text style={generalPageStyles.tableCellStart}>{packingList.shipmentNumber}</Text> */}
            <Text style={generalPageStyles.tableCellStart}>{packingList.customer?.accountNumber}</Text>
            {/* //TODO replace with data - order date */}
            <Text style={generalPageStyles.tableCellStart}>01/01/2020</Text>
            {/* //TODO replace with data - taxable */}
            <Text style={generalPageStyles.tableCellStart}>E</Text>
            {/* //TODO replace with data - sales rep */}
            <Text style={generalPageStyles.tableCellStart}>No Salesman</Text>
            <Text style={[generalPageStyles.tableCellStart, { flex: 3 }]}>{packingList.customerPO}</Text>
            {/* // TODO replace with data - mark shipment */}
            <Text style={[generalPageStyles.tableCellStart, generalPageStyles.tableCellEnd, { flex: 2 }]}></Text>
          </View>
          <View style={generalPageStyles.rowWithBorder2}>
            <Text style={[generalPageStyles.tableCellStart, { flex: 2 }]}>F.O.B. Point</Text>
            <Text style={generalPageStyles.tableCell}>Ship Date</Text>
            <Text style={[generalPageStyles.tableCell, generalPageStyles.tableCellEnd, { flex: 2 }]}>Shipped Via</Text>
          </View>
          <View style={generalPageStyles.rowWithBorder}>
            {/* //TODO replace with packingList.fob */}
            <Text style={[generalPageStyles.tableCellStart, { flex: 2 }]}>Origin</Text>
            <Text style={generalPageStyles.tableCellStart}>
              {packingList.shippedAt ? new Date(packingList.shippedAt).toLocaleDateString() : null}
            </Text>
            <Text style={[generalPageStyles.tableCellStart, generalPageStyles.tableCellEnd, { flex: 2 }]}>
              {packingList.shippingMethod}
            </Text>
          </View>
          <View style={[generalPageStyles.rowWithBorder2, { paddingBottom: rowPadding }]}></View>
          {/* bottom table */}
          <View style={generalPageStyles.rowWithBorder} fixed>
            <View style={generalPageStyles.tableCellStart}></View>
            <Text style={[generalPageStyles.tableCellStart, { flex: 3 }]}>Quantity</Text>
            <View style={generalPageStyles.tableCellStart}></View>
            <View style={[generalPageStyles.tableCellStart, { flex: 2 }]}></View>
            <View style={[generalPageStyles.tableCellStart, generalPageStyles.tableCellEnd, { flex: 2 }]}></View>
          </View>
          <View style={generalPageStyles.row} fixed>
            <Text style={generalPageStyles.tableCellStart}>Item</Text>
            <View style={[generalPageStyles.tableCellStart, generalPageStyles.rowWithBorder, { flex: 3 }]}>
              <Text style={styles.quantityCell}>Order</Text>
              <Text style={styles.quantityCell}>B/O</Text>
              <Text style={styles.quantityCell}>Ship</Text>
            </View>
            <Text style={generalPageStyles.tableCellStart}>Unit</Text>
            <Text style={[generalPageStyles.tableCellStart, { flex: 2 }]}>Product</Text>
            <Text style={[generalPageStyles.tableCellStart, generalPageStyles.tableCellEnd, { flex: 2 }]}>
              Description
            </Text>
          </View>
          {packingList.lines.map((line, index) =>
            typeof line !== 'string' ? (
              <View key={index} style={generalPageStyles.rowWithBorder} wrap={false}>
                <Text style={generalPageStyles.tableCellStart}>{`${line.orderLineNumber}${
                  line.orderReleaseNumber > 1 ? ` / ${line.orderReleaseNumber}` : ''
                }`}</Text>
                <Text style={generalPageStyles.tableCellStart}>
                  {typeof line.salesOrderLine !== 'string' ? line.salesOrderLine.quantity || '' : ''}
                </Text>
                <Text style={styles.quantityCell}>
                  {typeof line.salesOrderLine !== 'string' ? line.salesOrderLine.qtyOpen || '' : ''}
                </Text>
                <Text style={styles.quantityCell}>{line.packagedQuantity}</Text>
                <Text style={generalPageStyles.tableCellStart}>{line.productUnitOfMeasure}</Text>
                <Text style={[generalPageStyles.tableCellStart, { flex: 2 }]}>
                  {`${line.customerProductCode} Rev. ${line.productRevision}`}
                </Text>
                <Text style={[generalPageStyles.tableCellStart, generalPageStyles.tableCellEnd, { flex: 2 }]}>
                  {line.productDescription}
                </Text>
              </View>
            ) : null,
          )}
          <View style={generalPageStyles.rowWithBorder2}></View>
        </View>
        <Text
          style={generalPageStyles.pageNumber}
          render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
          fixed
        />
      </Page>
    </Document>
  );
};
